import { useTranslations } from '@vocab/react';
import { Stack, Box, Pagination } from 'braid-design-system';
import { useNavigate } from 'react-router-dom';

import ThreadsView from 'src/components/organisms/CommunityHome/ThreadsView';
import { FEATURED_THREADS_PAGE_SIZE } from 'src/core/domain/constants';
import { getPagePaths } from 'src/core/domain/pages';
import { useAuthStatus } from 'src/provider/auth';
import { useConfig } from 'src/provider/config';
import { usePage } from 'src/provider/page';
import { useThreads } from 'src/provider/threads';
import { fetchFeaturedThreads } from 'src/services/threadsService';

import translations from './.vocab';

export default () => {
  const {
    pageDispatch,
    pageState: { pageNumber },
  } = usePage();
  const {
    threadsState: { displayThreads, totalPage },
    threadsDispatch,
  } = useThreads();
  const { isAuthenticated } = useAuthStatus();
  const navigate = useNavigate();

  const { t } = useTranslations(translations);
  const { language, ...restConfigProps } = useConfig();
  const getLinkProps = ({ page }: { page: number }) => ({
    href: `${
      getPagePaths({ language, queryParams: { page: page.toString() } })
        .CommunityHome
    }`,
    onClick: async (e: any) => {
      e.preventDefault();
      navigate(`?page=${page}`, { replace: true });

      pageDispatch({ type: 'SET_PAGE_NUMBER', payload: { pageNumber: page } });

      const { threads } = await fetchFeaturedThreads({
        cursor: (page - 1) * FEATURED_THREADS_PAGE_SIZE,
        isAuthenticated,
        config: { language, ...restConfigProps },
      });
      threadsDispatch({
        type: 'UPDATE_THREADS',
        payload: { threads },
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  });

  return (
    <Stack
      space={{
        mobile: 'xsmall',
        tablet: 'xsmall',
        desktop: 'xsmall',
      }}
    >
      <ThreadsView />
      {displayThreads && displayThreads.length > 0 ? (
        <Box paddingY="xxlarge">
          <Pagination
            page={pageNumber || 1}
            total={totalPage || 1}
            linkProps={getLinkProps}
            label="Community Home"
            nextLabel={t('next')}
            previousLabel={t('previous')}
            data={{ testid: 'home-pagination' }}
          />
        </Box>
      ) : null}
    </Stack>
  );
};
